import { useNavigate } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import { PageHeader } from "../../../components/ui";

const INTAKE_LINKS = [
  { to: "/admin/raw-materials/paper", label: "Kağıt Giriş" },
  { to: "/admin/raw-materials/ink", label: "Boya Giriş" },
  { to: "/admin/raw-materials/lak", label: "Lak Giriş" },
  { to: "/admin/raw-materials/box", label: "Koli Giriş" },
  { to: "/admin/raw-materials/label", label: "Etiket Giriş" },
  { to: "/admin/raw-materials/shrink", label: "Shrink Giriş" },
];

export default function HammaddeHubPage() {
  const navigate = useNavigate();

  return (
    <Box>
      <PageHeader
        title="Hammadde"
        subtitle="Giriş türünü seçin."
      />
      <Stack spacing={1.5} sx={{ maxWidth: 420, mt: 3 }}>
        {INTAKE_LINKS.map(({ to, label }) => (
          <Button
            key={to}
            variant="contained"
            size="large"
            fullWidth
            onClick={() => navigate(to)}
            sx={{ justifyContent: "flex-start", py: 1.5, textTransform: "none", fontWeight: 600 }}
          >
            {label}
          </Button>
        ))}
      </Stack>
    </Box>
  );
}
